import {
  Component, Inject, OnInit
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AlertService } from "../../../services/alert.service";
import { VehicleCashout } from "./../../../models/vehicles/vehicle-cashout";
import { VehicleCashoutService } from "./../../../services/vehicle-cashout.service";

@Component({
  selector: "app-cashout-form-dialog",
  templateUrl: "./cashout-form-dialog.component.html",
  styleUrls: ["./cashout-form-dialog.component.css"],
})
export class CashoutFormDialogComponent implements OnInit {
  form: FormGroup = new FormGroup({
    vehicleId: new FormControl(0, [Validators.required, Validators.min(1)]),
    amount: new FormControl(0, [Validators.required, Validators.min(1)]),
    date: new FormControl(new Date(), [Validators.required]),
  });
  cashout: VehicleCashout = new VehicleCashout();
  loading: boolean = false;

  constructor(
    private _vehicleCashoutService: VehicleCashoutService,
    private _alertService: AlertService,
    private _dialog: MatDialogRef<CashoutFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    if (this.data.id > 0) {
      this.getExistingData();
    } else {
      this.cashout.vehicleId = this.data.vehicleId;
      this.setFormValues(this.cashout);
    }
  }

  private getExistingData() {
    this._vehicleCashoutService
      .getVehicleCashout(this.data.id)
      .subscribe((result) => {
        if (result.isSuccess) {
          this.cashout = result.data;
          this.setFormValues(this.cashout);
        } else {
          this._alertService.showError(result.error);
        }
      });
  }

  private setFormValues(vehicleCashout: VehicleCashout) {
    this.form.setValue({
      vehicleId: vehicleCashout.vehicleId,
      amount: vehicleCashout.amount,
      date: vehicleCashout.date,
    });
  }

  onFormSubmit(formValue) {
    if (!this.form.valid) {
      return; //do something here
    }

    //update
    this.cashout.id = this.data.id;
    this.cashout.vehicleId = formValue.vehicleId;
    this.cashout.amount = formValue.amount;
    this.cashout.date = formValue.date;

    this.loading = true;
    if (this.cashout.id == undefined || this.cashout.id < 1) {
      this.createVehicle();
    } else {
      this.updateVehicle();
    }
  }

  private createVehicle() {
    this._vehicleCashoutService
      .addVehicleCashout(this.cashout)
      .subscribe((result) => {
        if (result.isSuccess) {
          this._alertService.showSuccess("Cashout recorded.");
          this._dialog.close(true);
        } else {
          this._alertService.showError(result.error);
        }

        this.loading = false;
      });
  }

  private updateVehicle() {
    this._vehicleCashoutService
      .updateVehicleCashout(this.cashout)
      .subscribe((result) => {
        if (result.isSuccess) {
          this._alertService.showSuccess("Cashout record updated.");
          this._dialog.close(true);
        } else {
          this._alertService.showError(result.error);
        }
        this.loading = false;
      });
  }

  isControlInvalid(controlName: string) {
    let control = this.form.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  onCancel() {
    this._dialog.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/vehicles/cashout-form-dialog/cashout-form-dialog.component.ts